const modal = {
  el() {
    return $('.js-modal');
  },
  init() {
    this.event.on.click();
  },
  destroy() {
    this.event.off.click();
  },
  reInit() {
    this.destroy();
    this.init();
  },
  event: {
    on: {
      click() {
        const el = modal.el();
        el.on('click', modal.openModal);
      }
    },
    off: {
      click() {
        const el = modal.el();
        el.off('click', modal.openModal);
      }
    }
  },
  openModal(e) {
    console.log('click event');
    e.preventDefault();
    const thisEl = $(e.currentTarget);
    const thisTarget = thisEl.data('modal-target');
    const happeningsDetailBtn = $('body').find('.js-twsi-link-event');
    if (happeningsDetailBtn.length > 0) {
      console.log(happeningsDetailBtn);
      happeningsPageBuyTicket = true;
      happeningsPageBuyTicketUrl = happeningsDetailBtn.data('buy-ticket');
      happeningsPageCurrentUrl = happeningsDetailBtn.data('current-url') || window.location.href;
    }
    // if (frc.el.length > 0) {
    //   touristCard = true;
    // }
    MicroModal.show(thisTarget, {
      debugMode: true,
      disableScroll: true,
      awaitCloseAnimation: false,
      closeTrigger: 'data-modal-close'
    });
  },
  autoOpenModal(target) {
    MicroModal.show(target, {
      debugMode: true,
      disableScroll: true,
      awaitCloseAnimation: false,
      closeTrigger: 'data-modal-close'
    });
  },
  openModalById(id) {
    MicroModal.show(id, {
      debugMode: true,
      disableScroll: true,
      awaitCloseAnimation: false,
      closeTrigger: 'data-modal-close'
    });
  },
  closeModal(target) {
    console.log(target);
    MicroModal.close(target);
  }
};

$(document).ready(() => {
  modal.init();
});